module.exports = __webpack_public_path__ + "img/icon_land.6694fd80.svg";